module.exports = __webpack_public_path__ + "static/media/axa.3da537d8.jpg";